import {useCallback} from 'react';
import {IconButton} from 'components/button';
import type {CompareActionCompoent} from './types';
import {useDataFormContext} from '../contexts';
import {usePartChangeActionTooltip} from '../hooks/usePartChangeActionTooltip';

export const DataFormCompareDeleteValue: CompareActionCompoent = ({
  valuePath,
  part,
}) => {
  const {setApprovedValue} = useDataFormContext();
  const tooltip = usePartChangeActionTooltip('removeItem', part);

  const handleApprove = useCallback(() => {
    setApprovedValue(valuePath, 'removeItem', undefined, undefined);
  }, [setApprovedValue, valuePath]);

  return <IconButton icon="Delete" onClick={handleApprove} tooltip={tooltip} />;
};
